/** @jsxImportSource @emotion/react */
import { useRepeatHappeningMutation } from "@goodgym/graphql/hooks";
import * as T from "@goodgym/graphql/types";
import { useConfirm } from "@goodgym/hooks";
import { useNavigate } from "react-router-dom";
import {  toast } from "react-toastify";

export type RepeatHappeningMutationHookParams = {
  session: T.SessionFragment;
  date: string;
  time: string;
};

export type RepeatHappeningMutationHook = (
  defaults?: Partial<T.RepeatHappeningMutation>
) => (params: RepeatHappeningMutationHookParams) => React.MouseEventHandler;

const notify = () =>
  toast(
    " Session has been repeated successfully. You will now be redirected to the new session.", {
      type: "success",
    }
  );


export const useRepeatHappening: RepeatHappeningMutationHook = (defaults) => {
  const { confirm } = useConfirm();
    const navigate = useNavigate();
  const [repeatHappening] = useRepeatHappeningMutation({
    ...defaults,
    onError: console.log,
    onCompleted: (data) => {
     const slug = data?.response?.sessions?.[0]?.slug;
      if (slug) {
        notify();
        setTimeout(() => {
          navigate(`/v3/sessions/${slug}`);
        }, 2100); 
      }
    },
  });

  return ({ session, date, time }) =>


    (e) => {

      e?.preventDefault();
       if (!date || !time) {
         toast.warn(
           !date && !time
             ? "Please choose a date and a time."
             : !date
             ? "Please choose a date."
             : "Please choose a time."
         );
         return;
       }

   const dateObj = typeof date === "string" ? new Date(date) : date;
   if (isNaN(dateObj.getTime())) {
     toast.warn("The selected date is invalid.");
     return;
   }


      const yyyy = dateObj.getFullYear();
      const mm = String(dateObj.getMonth() + 1).padStart(2, "0");
      const dd = String(dateObj.getDate()).padStart(2, "0");
      const dateStr = `${yyyy}-${mm}-${dd}`;


    let timeStr = "00:00:00";
    if (time && time.length === 4) {
      timeStr = `${time.substring(0, 2)}:${time.substring(2, 4)}:00`;
    } else if (time && time.length === 5 && time.includes(":")) {
      timeStr = `${time}:00`;
    }
      confirm({
        title: `Repeat this session?`,
        text: `Are you sure you want to create a new session "${
          session.title
        }" on ${dateStr} at ${time.substring(0, 2)}:${time.substring(2, 4)}?`,
        onConfirm: () => {
          repeatHappening({
            variables: {
              happeningId: session.id,
              datesWithTime: [{ date: dateStr, time: timeStr }],
            },
          });
        },
      });
    };
};
